import KnowledgeBuilder from 'builders/builderKnowledge/configMode/Page';

export default function index() {
    return (
        <KnowledgeBuilder />
    );
}
